// Native bootstrap — runs only when packaged via Capacitor.
// On plain web (browser / PWA) it's a no-op.
let initialized = false;

export async function initNativeBridge() {
  if (initialized) return;
  initialized = true;

  try {
    const { Capacitor } = await import("@capacitor/core");
    if (!Capacitor.isNativePlatform()) return;

    // Status bar — dark theme, brand background
    try {
      const { StatusBar, Style } = await import("@capacitor/status-bar");
      await StatusBar.setStyle({ style: Style.Dark });
      await StatusBar.setBackgroundColor({ color: "#09090B" });
      await StatusBar.setOverlaysWebView({ overlay: false });
    } catch (e) { /* plugin not available */ }

    // Hide splash a touch after first paint
    try {
      const { SplashScreen } = await import("@capacitor/splash-screen");
      setTimeout(() => SplashScreen.hide({ fadeOutDuration: 400 }), 600);
    } catch (e) { /* noop */ }

    // Keyboard tweaks (Android)
    try {
      const { Keyboard } = await import("@capacitor/keyboard");
      Keyboard.setAccessoryBarVisible({ isVisible: false });
    } catch (e) { /* iOS only API silently fails */ }

    // Handle Android hardware back button — navigate browser history then exit
    try {
      const { App } = await import("@capacitor/app");
      App.addListener("backButton", ({ canGoBack }) => {
        if (canGoBack) window.history.back();
        else App.exitApp();
      });
    } catch (e) { /* noop */ }
  } catch (e) {
    // Capacitor not installed (shouldn't happen) — ignore
  }
}

// Light wrapper for haptic feedback (graceful fallback on web)
export async function hapticTap() {
  try {
    const { Haptics, ImpactStyle } = await import("@capacitor/haptics");
    await Haptics.impact({ style: ImpactStyle.Light });
  } catch (e) {
    if (navigator.vibrate) navigator.vibrate(10);
  }
}
